module.exports = __webpack_public_path__ + "files/c338a263d66356ab2c51816832f76911.png";